import React, { useEffect } from 'react';
import Skills from './Skills';
import '../styles/scrollEffect.css';

const Resume = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.resume-section');
      const triggerHeight = window.innerHeight / 1.2;

      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;

        if (sectionTop < triggerHeight) {
          section.classList.add('visible');
        } else {
          section.classList.remove('visible');
        }
      });
    };

    const scrollableDiv = document.getElementById('scrollable-content');
    scrollableDiv.addEventListener('scroll', handleScroll);
    return () => scrollableDiv.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div id="scrollable-content" className="scrollable-content">
      <h1 className="open">SCROLL DOWN</h1>
      <div className="arrow-down" aria-hidden="true"></div>
      <br />

      <div className="resume-section">
        <h2>Jake Pifer</h2>
        <p>Olympia, WA</p>
        <p>Email: jakepifer3@gmail.com</p>
        <p>Web: <a href="https://jpifer.com" className="link">jpifer.com</a></p>
        <p>GitHub: <a href="https://github.com/Jpifer13" className="link">Jpifer13</a></p>
        <br />
        <button className="download-btn" onClick={() => window.print()}>Download Resume</button>
      </div>

      <div className="resume-section">
        <p>A decade in software, the last eight years building backend and distributed systems on AWS  —  most of it as the first or lead engineer on the platform. Repeatedly taken backends from zero to production in regulated and high-stakes domains: SEC-regulated securities exchange, institutional crypto custody, bank merger data integration, clinical genomics. Deep in Python and serverless architecture; comfortable owning system design, infrastructure, and delivery end to end.</p>
      </div>

      <div className="resume-section">
        <h2>Experience</h2>
        <br />

        <h3>PwC  —  Lead Backend Engineer, Senior Associate</h3>
        <p className="italics">2025 – Present | Remote</p>
        <p>Hired by Kunai; joined PwC through its acquisition of Kunai in 2025.</p>
        <br />
        <p>Integrated Discover card servicing into Capital One infrastructure following the merger  —  built the card management flows for lost card replacement and new card issuance, and reconciled Discover cardholder data into Capital One systems with a zero-defect accuracy requirement.</p>
        <br />
        <p>Built LLM-backed internal tooling for PwC engagement teams: two systems automating repeatable manual processes end to end, and an interactive tool that evaluates prospective acquisition terms and qualifies them against deal criteria.</p>
        <br />
        <p>Building a system for Amazon that converts financial Excel models into modular web applications, translating spreadsheet formula semantics faithfully and holding exact decimal precision to the cent.</p>
        <br />

        <h3>Pixelum  —  Co-Founder & Lead Backend Engineer</h3>
        <p className="italics">2024 – Present | Part-time</p>
        <p>Co-founded a small backend engineering practice taking on client contract work, sustained alongside full-time engineering.</p>
        <br />
        <p>Lead architecture and delivery for CalioPro, a field service management platform with automated scheduling  —  currently serving pet care businesses, architected for expansion across additional service verticals.</p>
        <br />
        <p>Architected the multi-tenant backend on FastAPI with PostgreSQL, DynamoDB, and Redis, deployed on AWS Lambda and serverless infrastructure, currently running in production for a dozen service businesses.</p>
        <br />
        <p>Set engineering standards and lead a team of 4 engineers across 3 concurrent projects.</p>
        <br />

        <h3>JKBX  —  Founding Backend Engineer & Lead</h3>
        <p className="italics">2023 – 2024 | Remote</p>
        <p>First backend hire. Owned backend engineering end to end with 3 direct reports, reporting to the CTO  —  built the entire platform behind an SEC-regulated exchange that fractionalized music royalty rights into tradable securities, spanning API layer, microservices, infrastructure, and deployment pipeline.</p>
        <br />
        <p>Designed the data aggregation layer unifying third-party catalog data from Chartmetric and Gracenote with internal rights catalogs.</p>
        <br />
        <p>Built and owned microservices for user management, sessions, payments, and security transfer processes, working directly with compliance on transfer-agent requirements.</p>
        <br />
        <p>Established infrastructure-as-code practice from scratch using CloudFormation/SAM across API Gateway, Lambda, DynamoDB, RDS, S3, SQS/SNS, Step Functions, and ECR, with GitHub Actions CI/CD.</p>
        <br />

        <h3>Floating Point Group  —  Lead Backend Engineer</h3>
        <p className="italics">2022 | Remote</p>
        <p>Built platform tooling for an institutional crypto brokerage managing custody across multiple exchanges: authored custom CDK modules including cross-account dynamic DNS automation, replacing per-deployment manual DNS configuration.</p>
        <br />
        <p>Built the MetaMask Institutional integration from scratch alongside MetaMask engineers  —  webhook status monitoring service and on-chain transaction signing with private key management via Web3.py.</p>
        <br />
        <p>Served as the senior technical voice on the team, establishing testing practices and coding standards adopted across the project.</p>
        <br />

        <h3>Lululemon  —  Lead Backend Engineer</h3>
        <p className="italics">2021 – 2022 | Seattle, WA</p>
        <p>Led backend for the serverless VoIP platform that replaced landline phones across every Lululemon retail location in the US; the system has since expanded to international locations.</p>
        <br />
        <p>Architected three interoperating services: a softphone API for store smartphones, an experience layer generating daily usage reporting, and Twilio IVR call routing  —  all on Lambda, API Gateway, DynamoDB, and RDS with CloudFormation IaC.</p>
        <br />
        <p>Built Kafka event stream logging for the Reporting team, feeding call and usage data from the VoIP fleet into daily operational reports.</p>
        <br />
        <p>Mentored junior backend engineers and owned team DevOps via GitLab CI/CD.</p>
        <br />

        <h3>Q2 Solutions  —  Software Engineer</h3>
        <p className="italics">2019 – 2021 | Morrisville, NC</p>
        <p>Primary API developer on ADMS, the system controlling flow of all DNA/RNA sequencing data company-wide and slated to replace a legacy platform globally. Built the API layer from nothing to MVP.</p>
        <br />
        <p>Orchestrated Nextflow analysis pipeline invocation over Kafka, moving terabytes per day of sequencer output to downstream analysis systems.</p>
        <br />
        <p>Owned the flow of data between services that were each built and operated by a separate team, coordinating interfaces and handoffs across team boundaries.</p>
        <br />

        <h3>Earlier</h3>
        <p>Full Stack Developer, TOURtech (2018 – 2019)  —  one of two developers who built a crew coordination and network monitoring platform from scratch through first release (Python/Flask/Angular/PostgreSQL).</p>
        <br />
        <p>Freelance Web Developer (2016 – 2018)  —  built and maintained sites for 5 small business clients while completing degree, mostly e-commerce plus one inventory management system.</p>
      </div>

      <div className="resume-section">
        <h2>Skills</h2>
        <Skills />
      </div>

      <div className="resume-section">
        <h2>Education</h2>
        <br />
        <p>B.S. Computer Science  —  University of North Carolina at Wilmington, 2018</p>
        <p>Concentration: Systems | Cluster: Modeling</p>
      </div>

      <footer>
        <p>© {new Date().getFullYear()} Jake Pifer. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Resume;
